enum ContextMenuOptionType {
    OpenInNewTab ='OpenInNewTab'
}

export default ContextMenuOptionType;
